import helper, { getSlugByLang } from "../../common/Helper";
import noProfile from "../../assest/myImages/noprofile.png";
import circleComplete from "../../assest/images/circle-complete.png";
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles"
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { useSelector } from "react-redux";

const Form = ({
    state,
    changeValue,
    inputRef,
    handleNumberChange,
    handleValidityChange,
    phone,
    countryCode,
    handleFileChange,
    calendarRef,
    onClickSaveProfile,
    date, setDate, handleChangeDate,
    navigate

}) => {
    const { error } = state
    const user = useSelector((state) => state.user);
    const userLang = getSlugByLang(user?.language)
    return (
        <div className="rightProfile backLayerCom">
            <div className="importTitle profileBackbtnContainer">
                <h4 className="commonh3">Profile details</h4>
                <button type="button" className="customBtnGold" onClick={() => navigate('/' + userLang + '/profile')}>Back</button>

            </div>
            <div className="rightProfileMain">
                <div className="ourdetailProfile profileImport">
                    <div className="userImgBox">
                        {/* <img src="assest/images/user1.jpg" alt="user1" /> */}
                        <img
                            src={helper.S3Url + '/' + helper.profileImageDir + '/' + state?.profile_picture}
                            alt="noprofile"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = noProfile
                            }}
                        />
                        {/* <div className="updateImg">
                            <a href="javascript:void(0)"><i className="fa-solid fa-pen"></i> Update avatar</a>
                        </div> */}
                        <div className="updateImg">
                            <label htmlFor="avatarInput" className="custom-file-upload">
                                <i className="fa-solid fa-pen"></i> Update avatar
                            </label>
                            <input type="file" id="avatarInput" accept="image/*" onChange={(e) => handleFileChange(e)} />

                        </div>
                        {error && error.profile_picture && <span className="cus-err" style={{ position: "relative" }}>{error.profile_picture}</span>}
                    </div>
                    <div className="userPersonaldet">
                        <div className="innerFormBox">
                            <div className="box-box">
                                <label className="commonLabelSecond" htmlFor="">First name</label>
                                <input
                                    className="commonInputSecond"
                                    type="text"
                                    name="first_name"
                                    id="first_name"
                                    value={state.first_name}
                                    placeholder="Enter First name"
                                    onChange={(e) => changeValue(e)}
                                />
                                {error && error.first_name && <span className="cus-err">{error.first_name}</span>}

                            </div>
                            <div className="box-box">
                                <label className="commonLabelSecond" htmlFor="">Last name</label>
                                <input
                                    className="commonInputSecond"
                                    type="text"
                                    name="last_name"
                                    id="last_name"
                                    value={state.last_name}
                                    placeholder="Enter Last name"
                                    onChange={(e) => changeValue(e)}
                                />
                                {error && error.last_name && <span className="cus-err">{error.last_name}</span>}

                            </div>
                        </div>
                        <div className="toptitle">
                            <h5 className="formHeaderTitle"><img src={circleComplete} alt="circle-complete" />Contact</h5>
                        </div>
                        <div className="innerFormBox phoneBox profilePhoneInput">
                            <div className="box-box">
                                <label className="commonLabelSecond" htmlFor="">Phone number</label>
                                {/* <input
                                    className="commonInputSecond"
                                    type="phone"
                                    name="phone"
                                    id="text"
                                    placeholder="Enter your username"
                                    value={state.phone}
                                    onChange={(e) => changeValue(e)}

                                /> */}
                                <IntlTelInput
                                    ref={inputRef}
                                    initialValue={phone}
                                    defaultCountry={state.country_code}
                                    onChangeNumber={(e) => handleNumberChange(e)}
                                    onChangeValidity={(e) => handleValidityChange(e)}
                                    // formatOnDisplay={false}
                                    showFlags={true}
                                    initOptions={{
                                        initialCountry: state.country_code,
                                        separateDialCode: true,
                                        // geoIpLookup: geoIpLookup,
                                    }}

                                />
                                {error && error.phone && <span className="cus-err">{error.phone}</span>}
                                {error && !error.phone && error.country_code && <span className="cus-err">{error.country_code}</span>}

                            </div>
                            <div className="box-box">
                                <label className="commonLabelSecond" htmlFor="">Email</label>
                                <input className="commonInputSecond"
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="Enter Email"
                                    value={state.email}
                                    disabled
                                    onChange={(e) => changeValue(e)}
                                />
                                {error && error.email && <span className="cus-err">{error.email}</span>}
                            </div>
                        </div>
                        <div className="toptitle">
                            <h5 className="formHeaderTitle"><img src={circleComplete} alt="circle-complete" />Date of birth</h5>
                        </div>
                        {/* <div className="box-box">
                            <div className="bokunDropBox custom-cal">
                               
                                <i className="bi bi-calendar-week-fill"></i>
                                <input
                                    className="commonInputSecond"
                                    type="date"
                                    id="flat"
                                    ref={calendarRef} />
   

                                <div className="iconDown"><i className="fa-solid fa-chevron-down"></i></div>
                                {error && error.birth_date && <span className="cus-err">{error.birth_date}</span>}
                            </div>
                        </div> */}
                        <div className="box-box">
                            <div className="bokunDropBox custom-cal">

                                <DatePicker
                                    onChange={(e) => handleChangeDate(e)}
                                    value={state.birth_date}
                                    dayPlaceholder={''}
                                    yearPlaceholder={''}
                                    monthPlaceholder={''}
                                    clearIcon={null}
                                    format="dd/MM/yyyy"
                                    className={[]}
                                    maxDate={new Date()}

                                />


                                {/* <div className="iconDown"><i className="fa-solid fa-chevron-down"></i></div> */}
                                {error && error.birth_date && <span className="cus-err">{error.birth_date}</span>}
                            </div>
                        </div>

                    </div>
                </div>
                <div className="continueBox">
                    <button className="btn continueBtn" onClick={(e) => onClickSaveProfile(e)}>Save Changes</button>
                </div>
            </div>
        </div>
    )
}
export default Form;